import { Box } from '@mui/material'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { deadlineCategory, interestingsCategory } from '../state/notifications'
import { HotNewsDrawer, HotNewsHeaderAction, HotNewsTicker, InterestingsGrid, TodayDeadlines, TodayMenu, TodaySection } from './components/today'

const isSameUTCDay = (a, b) =>
  a.getUTCFullYear() === b.getUTCFullYear() &&
  a.getUTCMonth() === b.getUTCMonth() &&
  a.getUTCDate() === b.getUTCDate()

const isValidForToday = (notification) => {
  const now = new Date()

  const limitedMeta = notification.limited_event_metadata
  if (limitedMeta) {
    const start = limitedMeta.start_utc ? new Date(limitedMeta.start_utc) : null
    const end = limitedMeta.end_utc ? new Date(limitedMeta.end_utc) : null
    if (start && now < start) return false
    if (end && now > end) return false
    return true
  }

  const deadlineMeta = notification.deadline_metadata
  if (deadlineMeta?.deadline_utc) {
    return isSameUTCDay(now, new Date(deadlineMeta.deadline_utc))
  }

  return true
}

export const TodayHome = () => {
  const view = useSelector((state) => state?.todayMenu?.view ?? 'today')
  const { data: notifications } = useSelector((state) => state?.notifications)

  const [hotNewsOpen, setHotNewsOpen] = useState(false)

  let interestings = (notifications ?? []).filter((n) => n.category === interestingsCategory)
  let deadlines = (notifications ?? []).filter((n) => n.category === deadlineCategory)

  if (view === 'today') {
    interestings = interestings.filter(isValidForToday)
    deadlines = deadlines.filter(isValidForToday)
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <TodayMenu />
      <Box sx={{ width: '100%', maxWidth: '600px', margin: '0 auto', padding: '8px' }}>
        <Box sx={{ padding: '5px' }}>
          <Box sx={{ borderRadius: '5px', overflow: 'hidden' }}>
            <TodaySection
              title="Hot News"
              action={<HotNewsHeaderAction />}
              onHeaderClick={() => setHotNewsOpen(true)}
            >
              <HotNewsTicker />
            </TodaySection>
            {interestings.length > 0 && (
              <TodaySection title="Check it out!">
                <InterestingsGrid notifications={interestings} />
              </TodaySection>
            )}
            {deadlines.length > 0 && (
              <TodaySection title="Limited events">
                <TodayDeadlines notifications={deadlines} />
              </TodaySection>
            )}
          </Box>
        </Box>
      </Box>
      <HotNewsDrawer open={hotNewsOpen} onClose={() => setHotNewsOpen(false)} />
    </Box>
  )
}
